import React from 'react';
import PropTypes from 'prop-types';

import routes from 'app/routes';

import Step from '../Step';

import DisableButton from './Disable';
import FeedbackButton from './Feedback';

export default function ProgramFeedback({
  step, programId, showStep, setShowStep,
}) {
  const url = routes.members.programs.programFeedback(programId);

  const action = step.actions.find((item) => item.action === 'change_program_feedback'
  || item.action === 'create_program_feedback');

  return (
    <Step
      step={step}
      iconClassName="star-filled-icon bg-white"
      iconBg="bg-tertiary-1000"
      showStep={showStep}
      setShowStep={setShowStep}
    >
      {action && <FeedbackButton url={url} />}
      {!action && <DisableButton />}
    </Step>
  );
}

ProgramFeedback.propTypes = {
  step: PropTypes.object.isRequired,
  programId: PropTypes.number.isRequired,
  showStep: PropTypes.bool.isRequired,
  setShowStep: PropTypes.func.isRequired,
};
